<script>
    import { layoutOption, mode , queryStr } from '../store/inapp-store' 
    import { Modal, Loader } from '../components';
    import { getWalletStatus } from '../store/openpoint' 
    import { onMount } from 'svelte';

    $layoutOption.showBanner = false
    $layoutOption.showCarousel = false

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const payType = urlParams.get('payType')

    $:console.log('payType=', payType)

    let loader = { content : '錢包狀態確認中...' };
    let isBlock = true;

    let walletResult = {
        status: '',
        opw: '',
        icashpay: ''
    } 
    let modal = { 
        title : '登記借杯',
        message : '取得錢包狀態失敗，請稍候再試',
        type: 'alert'
    }
    
    let isOpen = false

    onMount(() =>{
        try {
            // 取得錢包狀態 (對應國泰收單行之功能 ，只提供至 2025/12月版)
            getWalletStatus()
        }catch(e) {
            if($mode === 'app') {
                modal.message  = e.msg
                isBlock = false
                isOpen = true
            }
        }

        let timer ;
        timer = setInterval(function(){

            // 根據所選payType判斷該種支付工具是否可用
            var walletStatus = document.getElementById('walletStatus').value;
            console.log('walletStatus', walletStatus)
            if(walletStatus !== '') {
                walletResult.status = walletStatus

                var isIcashpay = document.getElementById('isIcashpay').value;
                console.log('isIcashpay', isIcashpay)
                walletResult.icashpay = isIcashpay

                var isOpw = document.getElementById('isOpw').value;
                console.log('isOpw', isOpw)
                walletResult.opw = isOpw

                clearInterval(timer)

                // 錢包狀態回傳結果
                // Y:有任一支付工具 N:無任何支付工具 F:取得錢包失敗
                if(walletResult.status === 'Y') { 

                    // 舊線上支付判斷錢包狀態，icashpay直串判斷OP錢包內icashpay登入狀態
                    if(payType === 'online') {
                        nextStep()
                        return false
                    } else if(payType === 'icpo') {
                        if(walletResult.icashpay === 'Y') {
                            nextStep()
                            return false
                        } else {
                            modal.message  = '請至會員中心 → 支付管理登入icash Pay帳號'   
                            isBlock = false
                            isOpen = true
                        }
                    }
                } else {
                    if(walletResult.status === 'N')  {
                        modal.message  = '請先至OP錢包設定支付工具'
                    } 
                    isBlock = false
                    isOpen = true
                }
            }
            
        },1000) 

        if($mode !== 'app')  {
            setTimeout(function(){
                document.getElementById('walletStatus').value = 'Y'
                document.getElementById('isIcashpay').value = 'Y'
            },2000)
        }
    })
    
    function nextStep() {
        location.href = `/op-payment${payType === 'icpo' ? '-icp' : ''}`
    }

</script>

<input type="hidden" id="walletStatus" >
<input type="hidden" id="isOpw" >
<input type="hidden" id="isIcashpay" >

<Loader {loader} {isBlock}></Loader>
<Modal {modal} {isOpen} on:closeModal={e => location.href = `/home${$queryStr}`}></Modal>
